module.exports = "https://coursera_assets.s3.amazonaws.com/images/e0ccf30a2c70a69cf23ab7621621a673.png";